// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"create-new-company-modal_mainContent__1Q0kO"};